import global from "@/locales/sk-SK/global";
import error403 from "@/locales/sk-SK/errors/403";
import error404 from "@/locales/sk-SK/errors/404";
import error500 from "@/locales/sk-SK/errors/500";
import error503 from "@/locales/sk-SK/errors/503";
import error504 from "@/locales/sk-SK/errors/504";
import maintenance from "@/locales/sk-SK/auth/maintenance";
import toast from "@/locales/sk-SK/toast/toast";
import login from "@/locales/sk-SK/auth/login";
import onboarding from "@/locales/sk-SK/auth/onboarding";
import loginPageSteps from "@/locales/sk-SK/loginPageSteps";
import dashboard from "@/locales/sk-SK/dashboard/dashboard";
import account from "@/locales/sk-SK/account/account";
import mailbox from "@/locales/sk-SK/account/mailbox";
import bankstatement from "@/locales/sk-SK/account/bankstatement";
import myApps from "@/locales/sk-SK/my-apps/myApps";
import about from "@/locales/sk-SK/about/about";
import contactService from "@/locales/sk-SK/about/contactService";
import salesPromotions from "@/locales/sk-SK/sales/promotions";
import brochures from "@/locales/sk-SK/sales/brochures";
import shop from "@/locales/sk-SK/shop/data";
import priceList from "@/locales/sk-SK/shop/priceList";
import staff from "@/locales/sk-SK/dashboard/staff";
import promotions from "@/locales/sk-SK/promotions";
import points from "@/locales/sk-SK/points";
import trainings from "@/locales/sk-SK/trainings/trainings";
import vouchers from "@/locales/sk-SK/vouchers/vouchers";
import media from "@/locales/sk-SK/media/index";
import product from "@/locales/sk-SK/product/index";
import message from "@/locales/sk-SK/message/index";
import commitmentLetter from "@/locales/sk-SK/account/commitmentLetter";
import multiplicator from "@/locales/sk-SK/multiplicator";
import widgets from "@/locales/sk-SK/widgets/widgets";
import consents from "@/locales/sk-SK/consents/consents";
import investment from "@/locales/sk-SK/investment/data";
import kickback from "@/locales/sk-SK/kickback";
import portalHome from "@/locales/sk-SK/portal-home/portalHome";

//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.account,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  widgets: widgets.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  portalHome: portalHome.messages,
  productBrochures: {
    BDriveTitle: "Obrázky produktov",
    BDriveLinkText: "Odkaz na portál OBRÁZKOV PRODUKTOV",
  },
}

export default {
  locale: "sk-SK",
  messages,
};
